import script from "./Measurment-popup.vue?vue&type=script&setup=true&lang=js"
export * from "./Measurment-popup.vue?vue&type=script&setup=true&lang=js"

import "./Measurment-popup.vue?vue&type=style&index=0&id=fdd02dba&lang=scss&scoped=true"

import exportComponent from "/home/herman/Документи/Work/uhmi-web-maps/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fdd02dba"]])

export default __exports__